import TableCellLegendeErreurs from '../../Components/Includes/Table/TableCellLegendeErreurs'
import {
  color
} from '../Includes/Color'

export const properties = {
  type: {
    id: "erreurs",
    groupe: "legendes"
  },
  sort: {
    by: "",
    order: ""
  },
  columns: [
    {
      ...color
    },
    {
      id: "erreur",
      padding: true,
      component: TableCellLegendeErreurs
    }
  ]
}
